import { render, staticRenderFns } from "./IconStudy.vue?vue&type=template&id=2b9d999e&"
import script from "./IconStudy.vue?vue&type=script&lang=js&"
export * from "./IconStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports